// React をインポート
import React from 'react';
// リマインド日付変更ダイアログをインポート
import { UpdateSentAtModal } from './UpdateSentAtModal';
// プロパティインターフェースを定義
export interface UpdateSentAtModalLayoutProps {
  // リマインド日付
  reminderDate: string;
  // リマインドID
  selectedId: string;
  // ダイアログの開閉状態保持 (true：開く、false：閉じる)
  isModalOpen: boolean;
  // ダイアログクローズ時動作。openをfalseに変更
  onClose: () => void;
}
// リマインド日付を変更するダイアログ
export const UpdateSentAtModalLayout: React.FC<UpdateSentAtModalLayoutProps> = (props) => {
  // パラメータ
  const { reminderDate, selectedId, isModalOpen, onClose } = props;

  return (
    <UpdateSentAtModal
      // リマインド日付
      reminderDate={reminderDate}
      // リマインドID
      reminderId={selectedId}
      // ダイアログの開閉状態保持 (true：開く、false：閉じる)
      open={isModalOpen}
      // ダイアログクローズ時動作。openをfalseに変更
      onClose={onClose}
    />
  );
};
